import { Component, Inject, OnInit, Injector, Type } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-lazy-dialog-wrapper',
  template: `
    <div class="wrapper-container">
      <div *ngIf="loading" class="skeleton-wrapper">
        <div class="skeleton-header">
          <div class="shimmer title-shim"></div>
          <div class="shimmer close-shim"></div>
        </div>
        <div class="skeleton-body">
          <div class="shimmer text-shim-lg"></div>
          <div class="shimmer text-shim-md"></div>
          <div class="shimmer card-shim"></div>
          <div class="shimmer card-shim"></div>
        </div>
        <div class="skeleton-footer">
          <div class="shimmer btn-shim"></div>
          <div class="shimmer btn-shim-accent"></div>
        </div>
      </div>
      
      <ng-container *ngIf="!loading">
        <ng-container *ngComponentOutlet="loadedComponent; injector: customInjector"></ng-container>
      </ng-container>
    </div>
  `,
  styleUrls: ['./lazy-dialog-wrapper.component.scss']
})
export class LazyDialogWrapperComponent implements OnInit {
  loading = true;
  loadedComponent: Type<any> | null = null;
  customInjector: Injector;

  constructor(
    private parentInjector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: {
      loadFn: () => Promise<Type<any>>,
      componentData?: any,
      providers?: any[],
      dialogOptions?: {
        position?: any;
        width?: string;
        height?: string;
        panelClass?: string | string[];
        disableClose?: boolean;
      }
    },
    private dialogRef: MatDialogRef<LazyDialogWrapperComponent>
  ) {}

  async ngOnInit() {
    try {
      const options = this.data.dialogOptions;
      if (options) {
        if (options.position) {
          this.dialogRef.updatePosition(options.position);
        }
        if (options.width || options.height) {
          this.dialogRef.updateSize(options.width || '', options.height || '');
        }
        if (options.disableClose !== undefined) {
          this.dialogRef.disableClose = options.disableClose;
        }
        if (options.panelClass) {
          const classes = Array.isArray(options.panelClass) ? options.panelClass : [options.panelClass];
          classes.forEach(cls => {
            if (cls) {
              this.dialogRef.addPanelClass(cls);
            }
          });
        }
      }
      this.loadedComponent = await this.data.loadFn();
      
      const componentData = this.data.componentData || this.data;
      const customProviders = [
        { provide: MAT_DIALOG_DATA, useValue: componentData },
        { provide: MatDialogRef, useValue: this.dialogRef }
      ];

      if (this.data.providers && Array.isArray(this.data.providers)) {
        customProviders.push(...this.data.providers);
      }

      this.customInjector = Injector.create({
        providers: customProviders,
        parent: this.parentInjector
      });
      
      this.loading = false;
    } catch (err) {
      console.error('Failed to resolve lazy-loaded component in wrapper:', err);
      this.dialogRef.close(false);
    }
  }
}
